import Layout from "../../components/Layout";
import { capitalize, Paper, Typography } from "@mui/material";
import ErrorAlert from "../../components/ErrorAlert";
import { notPermitted } from "../../errors";
import React from "react";
import Guard from "../../components/Guard";
import { useT } from "../../i18n";
import EntsorgungsdokumentationDataTable from "../../components/entsorgungsdokumentationen/EntsorgungsdokumentationDataTable";
import {useNavigate} from "react-router";
import {EntsorgungsdokumentationSelectionProvider} from "../../contexts/EntsorgungsdokumentationSelectionContext";

function Entsorgungsdokumentation() {
  const { t: translation } = useT("entsorgungsdokumentation");
    const navigate = useNavigate();
  return (
      <Layout title={capitalize(translation("disposal-documentation"))} onBackClick={() => navigate(-1)}>
      <Guard
        permission={"entsorgungsdokumentation:generate"}
        fallback={<ErrorAlert error={notPermitted()} />}
      >
        <EntsorgungsdokumentationSelectionProvider>
          <Paper
            elevation={1}
            sx={{ marginTop: 2, padding: 3, marginLeft: 2, marginRight: 2 }}
          >
            <Typography variant="h5">
              {capitalize(translation("disposal-documentation"))}
            </Typography>
            <EntsorgungsdokumentationDataTable />
          </Paper>
        </EntsorgungsdokumentationSelectionProvider>
      </Guard>
    </Layout>
  );
}

export default Entsorgungsdokumentation;
